import { useEffect, useState } from 'react';
import { generateClassName } from '@klaviyo-mkt/gatsby-components/shared/utils/functions';
import { handleRegistrationButtonClick } from '../../../utils';

import type { AnchorHTMLAttributes, MouseEvent } from 'react';

import * as styles from './styles/registerButton.module.scss';
import * as buttonStyles from '@klaviyo-mkt/gatsby-components/atoms/button/styles/button.module.css';

interface IRegisterButton extends AnchorHTMLAttributes<HTMLAnchorElement> {
  isUserLoggedIn: boolean;
  registrationUrl?: string | null;
  resourceId: string;
  resourceType: string;
  resourceName: string;
  sendRegistrationEvent: boolean;
}

export const RegisterButton = ({
  children,
  className,
  isUserLoggedIn = false,
  registrationUrl,
  resourceId,
  resourceType,
  resourceName,
  sendRegistrationEvent,
  ...props
}: IRegisterButton) => {
  const [isLoading, setIsLoading] = useState(!isUserLoggedIn);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000); // fail safe timeout. don't wait for login information longer than 3 seconds

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isUserLoggedIn) {
      setIsLoading(false);
    }
  }, [isUserLoggedIn]);

  return (
    <a
      className={generateClassName([className, buttonStyles.button, styles.registerButton, isLoading && styles.loading])}
      onClick={(event: MouseEvent<HTMLAnchorElement>) => handleRegistrationButtonClick({
        event: event.nativeEvent,
        isUserLoggedIn,
        registrationUrl,
        resourceId,
        resourceType,
        resourceName,
        sendRegistrationEvent,
      })}
      {...props}
    >
      {isLoading ? 'Loading...' : children}
    </a>
  );
};
